import Vue from 'vue';
import VueRouter from 'vue-router';
import CMSView from '../components/CMSView';
import AccountView from '../components/Account/AccountView';
import Login from '../components/Account/Login';
import PasswordReset from '../components/Account/PasswordReset';
import Register from '../components/Account/Register';
import Cart from '../components/checkout/Cart';
import ContactForm from '../components/Forms/ContactForm';
import PaymentDetailsForm from '../components/checkout/PaymentDetailsForm';
import ReviewOrder from '../components/checkout/ReviewOrder';
import OrderComplete from '../components/checkout/OrderComplete';
import OrderFailed from '../components/checkout/OrderFailed';
import Redirecting from '../components/checkout/Redirecting';
import { viewports } from '../store/constants/viewports';
import store from '../store';
import TrackOrder from '../components/checkout/TrackOrder';
import Account from '../components/Account/Account';
import OrderDetails from '../components/Account/OrderDetails';
import EMailUpdate from '../components/Account/EMailUpdate';
import PasswordUpdate from '../components/Account/PasswordUpdate';
import QuoteGenerated from '../components/checkout/QuoteGenerated';
import ErrorPage from '../components/views/ErrorPage';
import Home from '../Home';
import { guard } from '../auth/auth-guard';

Vue.use(VueRouter);

const routes = [
    {
        path: '/not-available',
        name: 'NotAvailable',
        component: ErrorPage,
    },
    {
        path: '/account',
        component: Account,
        name: 'Account',
        beforeEnter: guard,
    },
    {
        path: '/login',
        component: Login,
        name: 'Login',
    },

    {
        path: '/register',
        component: Register,
        name: 'Register',
    },
    {
        path: '/optin/:optinId',
        component: Register,
        name: 'Register',
    },
    {
        path: '/reset-password',
        component: PasswordReset,
        name: 'SendPasswordResetLink',
        children: [
            {
                path: ':resetId?',
                component: PasswordReset,
                name: 'PasswordReset',
            },
        ],
    },
    {
        path: '/profile-update',
        component: AccountView,
        name: 'AccountView',
    },
    {
        path: '/mail-update',
        component: EMailUpdate,
        name: 'EMailUpdate',
    },
    {
        path: '/password-update',
        component: PasswordUpdate,
        name: 'PasswordUpdate',
    },

    {
        path: '/cart',
        component: Cart,
        name: 'Cart',
    },
    {
        path: '/payment-details',
        component: PaymentDetailsForm,
        name: 'PaymentDetails',
        children: [
            {
                path: ':orderId?',
                component: PaymentDetailsForm,
                name: 'UpdateOrder',
            },
        ],
    },
    {
        path: '/review-order',
        component: ReviewOrder,
        name: 'ReviewOrder',
        children: [
            {
                path: ':orderId?',
                component: PaymentDetailsForm,
                name: 'ReviewUpdatedOrder',
            },
        ],
    },
    {
        path: '/order-complete',
        component: OrderComplete,
        name: 'OrderComplete',
        children: [
            {
                path: ':orderId?',
                component: OrderComplete,
                name: 'OrderComplete',
            },
        ],
    },
    {
        path: '/quote-generated',
        component: QuoteGenerated,
        name: 'QuoteGenerated',
    },
    {
        path: '/track-order',
        component: TrackOrder,
        name: 'TrackOrder',
    },
    {
        path: '/order-details/:orderId',
        component: OrderDetails,
        name: '/OrderDetails',
    },
    {
        path: '/order-failed',
        component: OrderFailed,
        name: 'OrderFailed',
    },
    {
        path: '/redirecting',
        component: Redirecting,
        name: 'Redirecting',
    },
    {
        path: '/checkout',
        name: 'Checkout',
        // route level code-splitting
        // this generates a separate chunk (about.[hash].js) for this route
        // which is lazy-loaded when the route is visited.
        component: () =>
            import(
                /* webpackChunkName: "about" */ '../components/views/About.vue'
            ),
    },
    {
        path: '/:lang?/',
        name: 'App',
        component: Home,
        children: [
            {
                path: '',
                name: 'Home',
                component: CMSView,
                children: [
                    {
                        path: ':id',
                        component: CMSView,
                        name: 'CMSView',
                    },
                    {
                        path: ':id/*',
                        component: CMSView,
                        name: 'CMSViewSubpage',
                    },
                ],
            },
        ],
    },
];

const router = new VueRouter({
    mode: 'history',
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {

        window.scrollTo(0, 0);

    },
});

router.beforeEach((to, from, next) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
        event: 'PageView',
        pagePath: to.path,
        pageTitle: to.name || '',
    });
    next();
});

export default router;
